/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type LabReportMutationDtoEnzyme = (typeof LabReportMutationDtoEnzyme)[keyof typeof LabReportMutationDtoEnzyme];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabReportMutationDtoEnzyme = {
  KATG: 'KATG',
  INHA_PROMOTER: 'INHA_PROMOTER',
  RPOB: 'RPOB',
} as const;
